import { Flex } from '@chakra-ui/react';
import {
  LuTarget, LuShield, LuHouse, LuPlane, LuLaptop, LuSun, LuCar,
  LuGraduationCap, LuHeart, LuGift, LuPiggyBank, LuPawPrint,
} from 'react-icons/lu';
import { FALLBACK_GOAL_COLOR, hexToTint } from '../../utils/goals';

// A goal stores the key; the key picks the icon. Unknown keys fall back to the
// target, so a key added later never renders blank on an older build.
export const GOAL_ICONS = {
  target: LuTarget,
  shield: LuShield,
  home: LuHouse,
  plane: LuPlane,
  laptop: LuLaptop,
  sun: LuSun,
  car: LuCar,
  education: LuGraduationCap,
  health: LuHeart,
  gift: LuGift,
  savings: LuPiggyBank,
  pet: LuPawPrint,
};

/**
 * The goal's icon on a tinted disc. A disc, never a dot: tags already render as
 * coloured dots, and a goal must not read as one more tag.
 */
export default function GoalIcon({ goal, size = 28 }) {
  const color = goal?.color || FALLBACK_GOAL_COLOR;
  const Icon = GOAL_ICONS[goal?.icon] || LuTarget;
  return (
    <Flex
      w={`${size}px`}
      h={`${size}px`}
      borderRadius={`${Math.round(size * 0.3)}px`}
      bg={hexToTint(color)}
      color={color}
      align="center"
      justify="center"
      flexShrink={0}
    >
      <Icon size={Math.round(size * 0.55)} />
    </Flex>
  );
}
